export default {"src":"/_next/static/media/star-gradient.5472e45b.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};